import { deviceManager, isElectron, isMac, isWindows} from "../../libs/roomnew";

export default class DevicesSettings{
    constructor(lobby){
        this.cameraDeviceId=false;
        this.micDeviceId=false;
        this.speakerDeviceId=false;
        this.lobby=lobby;
        this.videoTrack=null;
        this.audioTrack=null;
        this.cameraIcon = `<svg class="voice-settings-icon" width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 0.5H16.75C18.125 0.5 19.25 1.625 19.25 3V13C19.25 14.375 18.125 15.5 16.75 15.5H3C1.625 15.5 0.5 14.375 0.5 13V3C0.5 1.625 1.625 0.5 3 0.5Z"></path><path d="M25.5 14.875L19.25 11.125V4.875L25.5 1.125V14.875Z"></path></svg>`;
        this.playAudioIcon = `<svg class="test-output-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 485 485" xml:space="preserve"><g><path d="M413.974,71.026C368.171,25.225,307.274,0,242.5,0S116.829,25.225,71.026,71.026C25.225,116.829,0,177.726,0,242.5s25.225,125.671,71.026,171.474C116.829,459.775,177.726,485,242.5,485s125.671-25.225,171.474-71.026C459.775,368.171,485,307.274,485,242.5S459.775,116.829,413.974,71.026z M242.5,455C125.327,455,30,359.673,30,242.5S125.327,30,242.5,30S455,125.327,455,242.5S359.673,455,242.5,455z"/><polygon points="181.062,336.575 343.938,242.5 181.062,148.425 	"/></g></svg>`;
        this.stopAudioIcon = `<svg class="test-output-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10z M500,928.7C263.6,928.7,71.3,736.4,71.3,500C71.3,263.6,263.6,71.3,500,71.3c236.4,0,428.7,192.3,428.7,428.7C928.7,736.4,736.4,928.7,500,928.7z"></path><path d="M622.5,316.2h-245c-33.8,0-61.2,27.4-61.2,61.2v245c0,33.8,27.4,61.3,61.2,61.3h245c33.8,0,61.3-27.4,61.3-61.3v-245C683.7,343.7,656.3,316.2,622.5,316.2z"></path></svg>`;
        this.changeNameIcon = false;
        this.testaudio;
        this.testAudioBars;
        this.dropDownArrow = `<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.175L8.825 -5.13609e-08L5 3.81667L1.175 -3.85753e-07L-5.13609e-08 1.175L5 6.175L10 1.175Z" fill="gray"/></svg>`;


    }

    // events(){
    //     let ds = this;
    //     ds.getMicrophoneDevices();
    // }


    removeModal(modal){
        let ds = this;
        modal.modal("hide");
        ds.destroyInstanceOfDevices();
        setTimeout(() => {
            if(modal !== null){
                modal.remove();
            }
        }, 200);
        if(ds.videoTrack){
            ds.stopTracks(ds.videoTrack);
        }
        if(ds.audioTrack){
            ds.stopTracks(ds.audioTrack);
        }
    };

    // FUNCTIONS TO RECORD VOICE AND ANIMATE THE BARS (NOT COMPLETELY READY)
    // voiceSettingsModalTestMicrophone() {
    //     function handleSuccess(stream) {
    //         if (window.stream) {
    //           window.stream.getAudioTracks().forEach(track => track.stop());
    //           window.stream = null;
    //         } else {
    //           const audio = document.createElement('audio');
    //           audio.controls = true;
    //           audio.autoplay = true;
    //           window.stream = stream;
    //           audio.srcObject = stream;

    //           stream.oninactive = function() {
    //             console.log('Stream ended');
    //           };
    //         }
    //       }

    //       function handleError(e){
    //         console.log("ruin", e.message);
    //       }

    //     if (navigator.mediaDevices) {
    //         const constraints = window.constraints = {
    //         audio: true,
    //         video: false
    //         }
    //         navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(handleError)
    //     }
    // };

    // voiceSettingsModalBars() {
    //     navigator.mediaDevices.getUserMedia({
    //         audio: true,
    //         video: true
    //       })
    //         .then(function(stream) {
    //             const audioContext = new AudioContext();
    //             const analyser = audioContext.createAnalyser();
    //             const microphone = audioContext.createMediaStreamSource(stream);
    //             const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

    //             analyser.smoothingTimeConstant = 0.8;
    //             analyser.fftSize = 1024;

    //             microphone.connect(analyser);
    //             analyser.connect(scriptProcessor);
    //             scriptProcessor.connect(audioContext.destination);
    //             scriptProcessor.onaudioprocess = function() {
    //             const array = new Uint8Array(analyser.frequencyBinCount);
    //             analyser.getByteFrequencyData(array);
    //             const arraySum = array.reduce((a, value) => a + value, 0);
    //             const average = arraySum / array.length;
    //             // console.log(Math.round(average));
    //             colorPids(average);
    //             };
    //         })
    //         .catch(function(err) {
    //             console.error(err);
    //         });
    // };

    getMicrophoneDevices(){
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            console.log("enumerateDevices() not supported.");
        }
        console.log("called getMicrophoneList");
        this.voiceSettingsDropdown.html('<h6 class="dropdown-header px-2">Microphone devices</h6>');
        KinoJS.mediaDevices.enumerateDevices((devices) => {
            let countdevices=devices.filter(d=>d.kind == "audioinput");

            devices.forEach((device)=>{
                let selected='';
                if (device.kind == "audioinput") {
                    if (device.label == "") {
                        device.label = device.deviceId;
                    }
                    if (this.micDeviceId == device.deviceId) {
                        selected = "selected";
                    }
                    let option=$("<a/>",{
                        class:`dropdown-item lobby-dropdown-item ${selected}`,
                        href:'#',
                        // title:device.label,
                        'device-id':device.deviceId,
                        html:`<i class="fas fa-microphone mr-1"></i> ${device.label}`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        // e.stopPropagation();
                        this.tryMicrophoneDevice(device.deviceId);
                    });
                    // let option = `<a class="dropdown-item audio-input-device ${selected}" href="#" device-id="${device.deviceId}" >${device.label}</a>`;
                    this.voiceSettingsDropdown.append(option);
                }
            });
            if(countdevices.length==0){
                // this.voiceSettingsDropdown.html('<option>No microphone found</option>');
                this.voiceSettingsDropdown.append($("<a/>",{
                    class:`dropdown-item lobby-dropdown-item`,
                    href:'#',
                    html:`No microphone found`
                }));
            }
        });

    }
    colorPids(vol) {
        // console.log("mic level changed",vol)
        const allPids = [...document.querySelectorAll('.pid.mic-devices')];
        const numberOfPidsToColor = Math.round(vol / 6);
        const pidsToColor = allPids.slice(0, numberOfPidsToColor);
        for (const pid of allPids) {
            // console.log(pid)
          pid.style.backgroundColor = "#e6e7e8";
        }
        for (const pid of pidsToColor) {
          // console.log(pid[i]);
          pid.style.backgroundColor = "#28a745";
        }
    };
    colorSpeakerPids(vol) {
        // console.log('Color speaker pid called ', vol)
        const allPids = [...document.querySelectorAll('.spid')];
        const numberOfPidsToColor = Math.round(vol / 2);
        const pidsToColor = allPids.slice(0, numberOfPidsToColor);
        for (const pid of allPids) {
          pid.style.backgroundColor = "#e6e7e8";
        }
        for (const pid of pidsToColor) {
          // console.log(pid[i]);
          pid.style.backgroundColor = "#69ce2b";
        }
    };

    connectMicToBars(stream){
        let ds=this;
        ds.destroyInstanceOfMics();
        ds.audioContext = new AudioContext();
        const analyser = ds.audioContext.createAnalyser();
        const microphone = ds.audioContext.createMediaStreamSource(stream);
        const scriptProcessor = ds.audioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(ds.audioContext.destination);
        scriptProcessor.onaudioprocess = function() {
            const array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            const arraySum = array.reduce((a, value) => a + value, 0);
            const average = arraySum / array.length;
            // console.log(Math.round(average));
            ds.colorPids(average);
        };
    };
    connectSpeakerToBars(audio){
        let ds=this;
        ds.destroyInstanceofSpeakers();
        ds.speakerAudioContext = new AudioContext();
        const analyser = ds.speakerAudioContext.createAnalyser();
        const microphone = ds.speakerAudioContext.createMediaElementSource(audio);
        const scriptProcessor = ds.speakerAudioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(ds.speakerAudioContext.destination);
        scriptProcessor.onaudioprocess = function() {
            const array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            const arraySum = array.reduce((a, value) => a + value, 0);
            const average = arraySum / array.length;
            // console.log(Math.round(average));
            ds.colorSpeakerPids(average);
        };
    };
    stopTracks(localTrack){
        try {
            if (localTrack && localTrack._originalStream) {
                localTrack._originalStream.getTracks().forEach(t=>t.stop());
                localTrack._originalStream = undefined;
            }
            localTrack.stream.getTracks().forEach(t=>t.stop());
        } catch (error) {
            console.error("end tracks error",error);
        }
    }

    onModalOpen(){
        // this.getMicrophoneDevices();
        // this.getCameraDeviceList();
        this.createTestSpeakerAudio();
        // this.getOutputDevicesList();
        // if(this.audioTrack){
        //     this.playMicTestBars(this.audioTrack);
        // }
        // this.playCameraPreview();
        console.log("selected speaker",this.speakerDeviceId);
        if(this.speakerDeviceId){
            this.tryChangeSpeakerId(this.speakerDeviceId);
        }
        this.tryMicrophoneDevice(this.micDeviceId);
        this.tryCameraDevice(this.cameraDeviceId);
    };

    playCameraPreview(){
        try {
            if(this.videoTrack){
                this.videoPreview.srcObject=this.videoTrack.stream;
            }
        } catch (error) {
            console.error(error);
        }
    };

    playMicTestBars(track){
        this.connectMicToBars(track.stream);
    };

    onSelectedCameraChanged(id){
        this.tryCameraDevice(id);
    };

    onSelectedMicChanged(id){
        this.tryMicrophoneDevice(id);
    };

    onSelectedSpeakerChanged(id){
        this.tryChangeSpeakerId(id);
    };
    tryChangeSpeakerId(id){
        this.speakerDeviceId=id;
        this.testaudio.setSinkId(id).then(()=>{
            console.log("Speaker device changed for audio",id);
            this.setSelectedSpeakerName(id);
        });
    }
    createTestSpeakerAudio(){
        this.testaudio=new Audio();
        this.testAudioBars = new Audio();
        this.testaudio.src= `${isElectron ? api.global.app_url : '' }/sounds/test-output.mp3`;
        this.testAudioBars.src = `${isElectron ? api.global.app_url : '' }/sounds/test-output.mp3`;
        this.audioPlaying=false;
        this.testaudio.onplaying=()=>{
            this.testOutputButton.text('Stop test')
            this.testOutputIcon.html(this.stopAudioIcon)
            this.audioPlaying=true;
        };
        this.testaudio.onended = (event) => {
            this.testOutputButton.text('Test audio');
            this.testOutputIcon.html(this.playAudioIcon);
            this.audioPlaying=false;
        };
        this.connectSpeakerToBars(this.testAudioBars);
    }
    playTestAudio(){
        try {
            this.testaudio.play();
            this.testAudioBars.play();
            this.audioPlaying=true;
        } catch (error) {
            console.error('start audio error ', error);
        }
    }
    stopTestAudio(){
        try {
            this.testaudio.pause();
            this.testAudioBars.pause();
            this.testaudio.currentTime=0;
            this.testAudioBars.currentTime=0;
            this.audioPlaying=false;
            this.testOutputButton.text('Test audio');
            this.testOutputIcon.html(this.playAudioIcon);
        } catch (error) {
            console.error("stop audio error",error);
        }
    }
    getCameraDeviceList(){
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            console.log("enumerateDevices() not supported.");
        }
        console.log("called getCameraList");
        this.cameraDevicesList.html('<h6 class="dropdown-header px-2">Camera devices</h6>');
        KinoJS.mediaDevices.enumerateDevices((devices) => {
            let countdevices=devices.filter(d=>d.kind == "videoinput");
            console.trace("Got camera devices",countdevices);

            devices.forEach((device)=>{
                let selected='';
                console.log("Found device with kind",device.kind)
                // if (device.kind == "videoinput") {
                //     if (device.label == "") {
                //         device.label = device.deviceId;
                //     }

                //     let option=$("<option/>",{
                //         value:device.deviceId,
                //         html:device.label.length > 30 ? device.label.slice(0,30)+"..." : device.label
                //     });
                //     if (this.cameraDeviceId == device.deviceId) {
                //         console.log("Found a camera matching id");
                //         option.attr('selected',"selected");
                //     }
                //     this.cameraDevicesList.append(option);
                //     console.log("option",this.cameraDevicesList);
                // }
                if (device.kind == "videoinput") {
                    if (device.label == "") {
                        device.label = device.deviceId;
                    }
                    if (this.cameraDeviceId == device.deviceId) {
                        selected = "selected";
                    }
                    let option=$("<a/>",{
                        class:`dropdown-item lobby-dropdown-item ${selected}`,
                        href:'#',
                        // title:device.label,
                        'device-id':device.deviceId,
                        html:`<i class="fas fa-video mr-1"></i> ${device.label}`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        // e.stopPropagation();
                        this.tryCameraDevice(device.deviceId);
                    });
                    // let option = `<a class="dropdown-item audio-input-device ${selected}" href="#" device-id="${device.deviceId}" >${device.label}</a>`;
                    this.cameraDevicesList.append(option);
                }

            });
            if(countdevices.length==0){
                // this.cameraDevicesList.html('<option>No camera found</option>');
            }
        });
    };
    async getDeviceName(id,type="audiooutput"){
        try {
            return new Promise((resolve,reject)=>{
               KinoJS.mediaDevices.enumerateDevices(devices=>{
                   for (let index = 0; index < devices.length; index++) {
                       const device = devices[index];
                       if (id == device.deviceId && device.kind==type) {
                           resolve(device.label);
                           return;
                       }
                   }
                   resolve(id);
               });
            });
        } catch (error) {
            return id;
        }
    };
    getOutputDevicesList(){
        console.log("called getOutputDevicesList");
        this.voiceSettingsOutputDropdown.html('<h6 class="dropdown-header px-2">Speaker devices</h6>');
        KinoJS.mediaDevices.enumerateDevices((devices) => {
            console.log("Got camera devices",devices);
            let countdevices=devices.filter(d=>d.kind == "audiooutput");
            devices.forEach((device)=>{
                let selected='';
                // if (device.kind == "audiooutput") {
                //     if (device.label == "") {
                //         device.label = device.deviceId;
                //     }
                //     let option=$("<option/>",{
                //         value:device.deviceId,
                //         html:device.label.length > 30 ? device.label.slice(0,30)+"..." : device.label
                //     });
                //     if (this.speakerDeviceId == device.deviceId) {
                //         option.attr('selected',"selected");
                //         this.testaudio.setSinkId(this.speakerDeviceId).then(()=>{
                //             console.log("output device for audio file changed",this.speakerDeviceId)
                //         });
                //     }
                //     this.voiceSettingsOutputDropdown.append(option);
                // }
                if (device.kind == "audiooutput") {
                    if (device.label == "") {
                        device.label = device.deviceId;
                    }
                    if (this.speakerDeviceId == device.deviceId) {
                        selected = "selected";
                    }
                    let option=$("<a/>",{
                        class:`dropdown-item lobby-dropdown-item ${selected}`,
                        href:'#',
                        // title:device.label,
                        'device-id':device.deviceId,
                        html:`<i class="fas fa-volume-up mr-1"></i> ${device.label}`
                    }).on('click',(e)=>{
                        e.preventDefault();
                        // e.stopPropagation();
                        this.tryChangeSpeakerId(device.deviceId);
                    });
                    // let option = `<a class="dropdown-item audio-input-device ${selected}" href="#" device-id="${device.deviceId}" >${device.label}</a>`;
                    this.voiceSettingsOutputDropdown.append(option);
                }
            });
            if(countdevices.length==0){
                this.voiceSettingsOutputDropdown.append($("<a/>",{
                    class:`dropdown-item lobby-dropdown-item`,
                    href:'#',
                    html:`No speakers found`
                }));
            }
        });
    };


    renderVoiceSettingsModal() {
        let l = this;
        if(l.voiceSettingsModal){l.removeModal(l.voiceSettingsModal)}
        localStorage.setItem('devices_settings_shown','yes');
        // l.voiceSettingsModalBars();
        console.log("lobby selected camera device id",l.lobby.cameraDeviceId)
        //get selected devices from lobby
        l.cameraDeviceId=l.lobby.cameraDeviceId;
        l.micDeviceId=l.lobby.micDeviceId;
        l.speakerDeviceId=deviceManager.lastUsedSpeaker();
        let videoSettingsDivider = $('<div/>',{
            class: 'voice-settings-divider',
            html: ''
        });

        // MICROPHONE
        let voiceSettingsTitle = $('<div/>',{
            class: 'voice-settings-title',
            html: 'Audio Settings'
        });
        // let voiceSettingsOption = $('<option/>',{
        //     value: "Microphone",
        //     html: 'Test Microphone'
        // });
        // l.voiceSettingsDropdown = $('<select/>',{
        //     class: 'form-control ignore-drag video-settings-dropdown',
        //     html: []
        // }).on('change',function(){
        //     l.onSelectedMicChanged($(this).val());
        // });
        this.voiceSettingsDropdown = $('<div/>',{
            class: 'dropdown-menu dropdown-menu-right dropdown-menu-white',
            'aria-labelledby': 'mic-dropdown-devices-settings',
            html: ''
        });
        this.micDropDown = $('<button/>',{
            class: 'btn-dropdown-lobby dropdown-icon devices-settings-dropdown-btn',
            type: 'button',
            'data-toggle': "dropdown",
            'aria-haspopup': "true",
            'aria-expanded': "false",
            id: 'mic-dropdown-devices-settings',
            html: 'Select microphone ' + this.dropDownArrow
        }).on('click',e=>{

            if(!this.voiceSettingsDropdown.hasClass('show')){
                // this.getCameraList();
                this.getMicrophoneDevices();
            }
        })
        this.micDropDownWrapper = $('<div/>',{
            class: 'dropdown dropdown-devices-settings d-flex align-items-center',
            html: [this.micDropDown, this.voiceSettingsDropdown]
        });

        let microphoneTestIcon = $('<span/>',{
            class: '',
            html: '<i class="fas fa-microphone mr-1" style="color: #032836;"></i>',
        });
        let microphoneTestLabel = $('<label/>',{
            class: 'video-settings-label',
            html: 'Microphone',
        });
        let microphoneTestIconLabel = $('<div/>',{
            class: 'd-flex',
            html: [microphoneTestIcon, microphoneTestLabel]
        });
        let microphoneTestBar = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar2 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar3 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar4 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar5 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar6 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar7 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar8 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar9 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar10 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar11 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar12 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestBar13 = $('<div/>',{
            class: 'pid mic-devices',
            html: ''
        });
        let microphoneTestDiv = $('<div/>',{
            class: 'microphone-test-div',
            html: [microphoneTestIconLabel, l.micDropDownWrapper]
        });
        let microphoneTestPids = $('<div/>',{
            class: 'pids-wrapper',
            html: [
                microphoneTestBar, microphoneTestBar2, microphoneTestBar3, microphoneTestBar4, microphoneTestBar5,
                microphoneTestBar6, microphoneTestBar7, microphoneTestBar8, microphoneTestBar9, microphoneTestBar10,
                microphoneTestBar11, microphoneTestBar12, microphoneTestBar13
            ]
        });
        let microphoneTestContainer = $('<div/>',{
            class: 'audio-settings-container',
            html: [microphoneTestDiv, microphoneTestPids]
        });
        this.micErrorMessage=$("<span/>",{
            class:"red-color d-block text-center",
        });
        let audioSettingsContainer = $('<div/>',{
            class: 'audio-settings-container',
            html: [voiceSettingsTitle, microphoneTestContainer, this.micErrorMessage,videoSettingsDivider]
        });


        // SPEAKER
        let speakerTestBar = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar2 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar3 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar4 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar5 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar6 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar7 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar8 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar9 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar10 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar11 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar12 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestBar13 = $('<div/>',{
            class: 'spid',
            html: ''
        });
        let speakerTestPids = $('<div/>',{
            class: 'pids-wrapper',
            html: [
                speakerTestBar, speakerTestBar2, speakerTestBar3, speakerTestBar4, speakerTestBar5,
                speakerTestBar6, speakerTestBar7, speakerTestBar8, speakerTestBar9, speakerTestBar10,
                speakerTestBar11, speakerTestBar12, speakerTestBar13
            ]
        });
        let speakerOutputTestContainer = $('<div/>',{
            class: 'audio-settings-container',
            html: [speakerTestPids]
        });

        let voiceSettingsOutputIcon = $('<span/>',{
            class: '',
            html: '<i class="fas fa-volume-up mr-1" style="color: #032836;"></i>',
        });
        let voiceSettingsOutputLabel = $('<label/>',{
            class: 'video-settings-label',
            html: 'Speaker'
        });
        let voiceSettingsOutputDiv = $('<div/>',{
            class: 'd-flex align-items-baseline',
            html: [voiceSettingsOutputIcon, voiceSettingsOutputLabel]
        });
        let voiceSettingsOutputOption = $('<option/>',{
            value: "Speaker",
            html: 'Test Speaker'
        });
        // this.voiceSettingsOutputDropdown = $('<select/>',{
        //     class: 'form-control ignore-drag video-settings-dropdown',
        //     html: voiceSettingsOutputOption
        // }).on('change',function(){
        //     l.onSelectedSpeakerChanged($(this).val());
        // });
        this.voiceSettingsOutputDropdown = $('<div/>',{
            class: 'dropdown-menu dropdown-menu-right dropdown-menu-white',
            'aria-labelledby': 'speaker-dropdown-devices-settings',
            html: ''
        });
        this.speakerDropDown = $('<button/>',{
            class: 'btn-dropdown-lobby dropdown-icon devices-settings-dropdown-btn',
            type: 'button',
            'data-toggle': "dropdown",
            'aria-haspopup': "true",
            'aria-expanded': "false",
            id: 'speaker-dropdown-devices-settings',
            html: 'Select speaker ' + this.dropDownArrow
        }).on('click',e=>{

            if(!this.voiceSettingsOutputDropdown.hasClass('show')){
                // this.getCameraList();
                this.getOutputDevicesList();
            }
        })
        this.speakerDropDownWrapper = $('<div/>',{
            class: 'dropdown dropdown-devices-settings d-flex align-items-center',
            html: [this.speakerDropDown, this.voiceSettingsOutputDropdown]
        });

        let speakerContainer = $('<div/>',{
            class: 'output-test-div',
            html: [voiceSettingsOutputDiv, this.speakerDropDownWrapper]
        });
        this.testOutputIcon = $('<span/>',{
            class: '',
            html: l.playAudioIcon
        });
        this.testOutputButton = $('<button/>',{
            class: 'test-output-button',
            html: 'Test audio',
        });
        let testOutputContainer = $('<div/>',{
            class: 'test-output-container',
            html: [this.testOutputIcon,this.testOutputButton],
        }).on('click', function(){
            if(l.audioPlaying){
                l.stopTestAudio();
            }else{
                l.playTestAudio();
            }
        });

        let speakerTestContainer = $('<div/>',{
            class: 'audio-settings-container',
            html: [speakerContainer, speakerOutputTestContainer, testOutputContainer]
        });


        // CAMERA
        let videoSettingsTitle = $('<div/>',{
            class: 'voice-settings-title',
            html: 'Video Settings'
        });

        let videoSettingsIcon = $('<span/>',{
            class: '',
            html: l.cameraIcon
        });
        let videoSettingsLabel = $('<label/>',{
            class: 'video-settings-label',
            html: 'Camera'
        });
        let videoSettingsDiv = $('<div/>',{
            class: 'd-flex',
            html: [videoSettingsIcon, videoSettingsLabel]
        });
        // this.cameraDevicesList = $('<select/>',{
        //     class: 'form-control ignore-drag video-settings-dropdown',
        //     id: 'video_settings',
        // }).on('change',function(){
        //     l.onSelectedCameraChanged($(this).val());
        // });
        this.cameraDevicesList = $('<div/>',{
            class: 'dropdown-menu dropdown-menu-right dropdown-menu-white',
            'aria-labelledby': 'camera-dropdown-devices-settings',
            html: ''
        });
        this.cameraDropDown = $('<button/>',{
            class: 'btn-dropdown-lobby dropdown-icon devices-settings-dropdown-btn',
            type: 'button',
            'data-toggle': "dropdown",
            'aria-haspopup': "true",
            'aria-expanded': "false",
            id: 'camera-dropdown-devices-settings',
            html: 'Select camera ' + this.dropDownArrow
        }).on('click',e=>{

            if(!this.cameraDevicesList.hasClass('show')){
                // this.getCameraList();
                this.getCameraDeviceList();
            }
        })
        this.cameraDropDownWrapper = $('<div/>',{
            class: 'dropdown dropdown-devices-settings d-flex align-items-center',
            html: [this.cameraDropDown, this.cameraDevicesList]
        });
        let videoTestDiv = $('<div/>',{
            class: 'video-test-div',
            html: [videoSettingsDiv, this.cameraDropDownWrapper]
        });

        let videoSettingsContainer = $('<div/>',{
            class: 'audio-settings-container',
            html: [videoSettingsTitle, videoTestDiv]
        });
        this.videoPreview=document.createElement('video');
        this.videoPreview.autoplay=1;
        let videoTestContainer = $('<div/>',{
            class: 'video-test-container',
            html: this.videoPreview
        });


        // SPLIT ELEMENTS
        let inputContainer = $('<div/>',{
            class: 'input-container',
            html: [audioSettingsContainer, speakerTestContainer]
        });
        this.cameraErrorMessage=$("<span/>",{
            class:"red-color d-block text-center pt-4"
        });
        let outputContainer = $('<div/>',{
            class: 'output-container',
            html: [videoSettingsContainer, videoTestContainer,this.cameraErrorMessage]
        });
        let containerDivider = $('<div/>',{
            class: 'container-divider',
            html: ''
        });
        let containerDividerDiv = $('<div/>',{
            class: 'container-divider-div',
            html: containerDivider
        });

        let bodyContainer = $('<div/>',{
            class: 'body-container-audio-settings',
            html: [inputContainer, containerDividerDiv, outputContainer]
        });


        // BODY
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: [bodyContainer],
            style: 'width: 95%;'
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            if(l.audioPlaying){
                l.stopTestAudio();
            }
            l.removeModal(l.voiceSettingsModal);
        });
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="modal-title text-center ignore-drag noselect">Device Settings</h4>`, closeModalBtn]
        });

        let cancelVoiceSettingsBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel",
            'data-dismiss': "modal"
        }).on('click', () => {
            if(l.audioPlaying){
                l.stopTestAudio();
            }
        });
        let saveVoiceSettingsBtn = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            type: "button",
            html: "Save Settings"
        }).on('click', ()=>{
            this.lobby.setDeviceSettings({
                audioDeviceId:this.micDeviceId,
                cameraDeviceId: this.cameraDeviceId,
                speakerDeviceId: this.speakerDeviceId
            });
            if(l.audioPlaying){
                l.stopTestAudio();
            }
            l.removeModal(l.voiceSettingsModal);
        });
        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: [cancelVoiceSettingsBtn, saveVoiceSettingsBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content kino-enhanced-modal',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-inside-kino",
            role: "document",
            html: modalContent,
            style: "max-width: 820px !important;"
        });

        l.voiceSettingsModal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            tabindex: "-1",
            role: "dialog",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                if(l.audioPlaying){
                    l.stopTestAudio();
                }
                l.removeModal(l.voiceSettingsModal);
            }
        }).on('hidden.bs.modal', function(e){
            l.destroyInstanceOfDevices();
        });

        $('body').append(l.voiceSettingsModal);
        l.voiceSettingsModal.modal('show');
        this.onModalOpen();
    }


    tryMicrophoneDevice(id){
        this.micDeviceId=id;
        this.voiceSettingsDropdown.val(id);
        deviceManager.getAudioTrack(id).then(audioTrack=>{
            if(this.audioTrack){
                //stop previous captured mic
                this.stopTracks(this.audioTrack);
            }
            this.audioTrack=audioTrack[0];
            this.micDeviceId=audioTrack[0].deviceId;
            // deviceManager.saveMic(audioTrack[0].deviceId);
            this.playMicTestBars(this.audioTrack);
            this.setMicrophoneOn();
            this.getMicrophoneDevices();
            this.getOutputDevicesList();
            this.setSelectedMicrophoneName(this.audioTrack.track.label);
        }).catch(err=>{
            this.setMicrophoneOff(err);
        });
    };

    setMicrophoneOn(){
        this.micErrorMessage.html('');
    };

    setMicrophoneOff(error=false){
        if(error){
            this.micErrorHandler(error);
        }
    };


    tryCameraDevice(id){
        this.cameraDeviceId=id;
        this.cameraDevicesList.val(id);
        deviceManager.getCameraTrack(id).then(async cameraTracks=>{
            console.log("Success getting camera track",cameraTracks[0]);
            this.cameraDeviceId=cameraTracks[0].deviceId;
            if(this.videoTrack){
                //stop previous captured mic
                this.stopTracks(this.videoTrack);
            }
            // deviceManager.saveCamera(cameraTracks[0].deviceId);

            // if(this.vbActive){
            //     vb.effect=this.vbActive;
            //     cameraTracks[0]=await vb.runEffect(cameraTracks[0]);
            // }
            this.videoTrack=cameraTracks[0];
            this.playCameraPreview();
            // this.localVideoPreview.srcObject=cameraTracks[0].stream;
            this.setCameraOn();
            this.setSelectedCameraName(this.videoTrack.track.label);
            // this.getCameraDeviceList();
        }).catch(err=>{
            console.error(err.message);
            this.setCameraOff(err);
        })
    };

    setCameraOn(){
        this.cameraErrorMessage.html('');
    }
    setCameraOff(error){
        this.videoPreview.srcObject=null;
        if(error){
            this.cameraErrorHandler(error);
        }
    }

    cameraErrorHandler(error) {
        var dm = this;
        console.error('error message: ', error.message);
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                    dm.cameraErrorMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "NotReadableError":
                    dm.cameraErrorMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                    deviceManager.resetCameraDevice((hasCameras=>{
                        if(hasCameras && !this.stopRetryCamera){
                            this.stopRetryCamera=true;
                            this.cameraDeviceId=deviceManager.lastUsedCamera();
                            this.tryCameraDevice(false);
                        }
                }));
                break;
            case "gum.unsupported_resolution":
                // dm.resetCameraDevice();
                // break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.cameraErrorMessage.html(`Camera access has been denied. Check for a camera icon in the browser's search bar, allow access, then refresh.`);

                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.cameraErrorMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "OverconstrainedError":

            default:
                dm.cameraErrorMessage.html(`We couldn't access the camera. Please make sure the camera is connected and is not being used by another application. Try selecting the camera again from the drop down menu when ready.`);;
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.cameraErrorMessage.html(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.cameraErrorMessage.html(`
                    Grant access to Kino in Privacy & Security in order to use your camera.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };


    micErrorHandler(error) {
        var dm = this;
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                dm.micErrorMessage.html(`Can't access microphone`);
                break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.micErrorMessage.html(`Microphone permission denied`)
                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.micErrorMessage.html(`Can't find selected microphone`);
                break;
            case "OverconstrainedError":

            default:
                dm.micErrorMessage.html(`Error getting microphone`);;
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.micErrorMessage.html(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.micErrorMessage.html(`
                    Grant access to Kino in Privacy & Security in order to use your microphone.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };

    updateDeviceList(){
        if(this.cameraDevicesList){
            // this.getCameraDeviceList();
        }
        if(this.voiceSettingsDropdown){
            this.getMicrophoneDevices();
        }
        if(this.voiceSettingsOutputDropdown){
            this.getOutputDevicesList();
        }
    };

    destroyInstanceOfMics(){
        let ds = this;
        if(ds.audioContext){
            ds.audioContext.close();
            ds.audioContext=null;
        }
    }
    destroyInstanceofSpeakers(){
        let ds = this;
        if(ds.speakerAudioContext){
            ds.speakerAudioContext.close();
            ds.speakerAudioContext=null;
        }
    }
    destroyInstanceOfDevices(){
        let ds = this;
        ds.destroyInstanceOfMics();
        ds.destroyInstanceofSpeakers();
    }

    setSelectedCameraName(name){
        console.log(`Camera name length is`,name.length)
        let nameFormatted= name.length >= 23 ? name.slice(0,20)+"..." : name;
        this.cameraDropDown.html(`${nameFormatted} ${this.dropDownArrow}`)
    }
    setSelectedMicrophoneName(name){
        console.log(`Microphone name length is`,name.length)
        let nameFormatted= name.length >= 23 ? name.slice(0,20)+"..." : name;
        this.micDropDown.html(`${nameFormatted} ${this.dropDownArrow}`)
    }
    async setSelectedSpeakerName(id){
        let name=await this.getDeviceName(id);
        let nameFormatted= name.length >= 27 ? name.slice(0,24)+"..." : name;
        this.speakerDropDown.html(`${nameFormatted} ${this.dropDownArrow}`)
    }
}
